import { IncludedProductComponent, PlannerEcsSystem, ProductInfoComponent, ProductType, UnavailableProductComponent, IncludedShelfComponent, NonBehaviorDeleteComponent, PlannerProductComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils, SelectableComponent } from '@inter-ikea-core/core';
export class CornerSolutionShelfSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'CornerSolutionShelfSystem', ComponentIds.IN_SCENE_COMPONENT_ID);
        this.coreApi = coreApi;
        this.mandatoryComponents = [PlannerProductComponent.id];
    }
    onAdd(entity) {
        const parent = HierarchyUtils.parent(entity);
        if (this.coreApi.entities.isProductType(entity, ProductType.PAX_SHELF) &&
            parent &&
            this.coreApi.entities.isProductType(parent, ProductType.PAX_ADD_ON_CORNER_FRAME)) {
            this.addComponentToIncludedShelves(entity, parent);
        }
    }
    onUpdate() { }
    onRemove() { }
    addComponentToIncludedShelves(shelf, cornerFrame) {
        const frameDesign = cornerFrame.getComponent(ProductInfoComponent.id)
            ?.design;
        const shelfDesign = shelf.getComponent(ProductInfoComponent.id)?.design;
        if (frameDesign !== shelfDesign) {
            return;
        }
        const includedShelves = HierarchyUtils.getDescendantsWithComponent(cornerFrame, IncludedShelfComponent.id);
        if (includedShelves.length < 4) {
            shelf.addComponent(new IncludedShelfComponent());
            shelf.addComponent(new IncludedProductComponent());
            shelf.addComponent(new NonBehaviorDeleteComponent());
            if (shelf.hasComponent(UnavailableProductComponent.id)) {
                shelf.removeComponent(UnavailableProductComponent.id);
                shelf.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
                shelf.addComponent(new SelectableComponent());
            }
        }
    }
}
//# sourceMappingURL=CornerSolutionShelfSystem.js.map